module.exports = __webpack_public_path__ + "img/材料力学8_5.a6100da3.jpg";